<template>
  <footer class="bohemia-footer" v-once>
    <div class="bohemia-footer-container">
      <div class="bohemia-footer-grid bohemia-footer-grid-links">
        <div class="bohemia-footer-grid-item bohemia-footer-grid-item-grow">
          <h4 class="bohemia-footer-title">INDEX</h4>
          <ul class="bohemia-footer-list">
            <li>
              <a href="https://www.bohemia.net">
                Home
              </a>
            </li>
            <li>
              <a href="https://www.bohemia.net/blog">
                Blog
              </a>
            </li>
            <li>
              <a href="https://store.bistudio.com">
                Store
              </a>
            </li>
            <li>
              <a href="https://support.bohemia.net">
                Support
              </a>
            </li>
            <li>
              <a href="https://account.bistudio.com">
                Account
              </a>
            </li>
          </ul>
        </div>
        <div class="bohemia-footer-grid-item bohemia-footer-grid-item-grow">
          <h4 class="bohemia-footer-title">GAMES</h4>
          <ul class="bohemia-footer-list">
            <li>
              <a href="http://www.arma3.com" target="_blank">
                Arma 3
              </a>
            </li>
            <li>
              <a href="http://www.arma2.com" target="_blank">
                Arma 2
              </a>
            </li>
            <li>
              <a href="http://www.armatactics.com" target="_blank">
                Arma Tactics
              </a>
            </li>
            <li>
              <a href="http://www.dayz.com" target="_blank">
                DayZ
              </a>
            </li>
            <li>
              <a href="http://mars.takeonthegame.com" target="_blank">
                Take On Mars
              </a>
            </li>
          </ul>
        </div>
        <div class="bohemia-footer-grid-item bohemia-footer-grid-item-grow">
          <h4 class="bohemia-footer-title">COMPANY</h4>
          <ul class="bohemia-footer-list">
            <li>
              <a href="https://www.bohemia.net/company/about">
                Profile
              </a>
            </li>
            <li>
              <a href="https://www.bohemia.net/company/careers">
                Careers
              </a>
            </li>
            <li>
              <a href="https://pro.bohemia.net">
                Services
              </a>
            </li>
            <li>
              <a href="https://www.bohemia.net/company/brochure">
                Brochure
              </a>
            </li>
            <li>
              <a href="https://www.bohemia.net/company/contacts">
                Contacts
              </a>
            </li>
          </ul>
        </div>
        <div class="bohemia-footer-grid-item bohemia-footer-grid-item-grow">
          <h4 class="bohemia-footer-title">COMMUNITY</h4>
          <ul class="bohemia-footer-list">
            <li>
              <a href="https://forums.bistudio.com">
                Forums
              </a>
            </li>
            <li>
              <a href="https://community.bistudio.com">
                Wiki
              </a>
            </li>
            <li>
              <a href="https://www.bohemia.net/community/licenses">
                Licences
              </a>
            </li>
            <li>
              <a
                href="https://www.bohemia.net/community/game-content-usage-rules"
              >
                Game Content Usage
              </a>
            </li>
            <li>
              <a href="https://www.bohemia.net/monetization">
                Server Monetization
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="bohemia-footer-divider" />

      <div class="bohemia-footer-grid bohemia-footer-grid-social">
        <div class="bohemia-footer-grid-item">
          <a href="https://www.facebook.com/BohemiaInteractive" target="_blank">
            <Icon
              type="facebook"
              :rounded="true"
              backgroundColor="#3a5ba2"
              borderColor="#3a5ba2"
            />
          </a>
        </div>
        <div class="bohemia-footer-grid-item">
          <a href="https://twitter.com/bohemiainteract" target="_blank">
            <Icon
              type="twitter"
              :rounded="true"
              backgroundColor="#1ebef0"
              borderColor="#1ebef0"
            />
          </a>
        </div>
        <div class="bohemia-footer-grid-item">
          <a
            href="https://www.youtube.com/user/BohemiaInteract"
            target="_blank"
          >
            <Icon
              type="youtube"
              :rounded="true"
              backgroundColor="#bb0000"
              borderColor="#bb0000"
            />
          </a>
        </div>
        <div class="bohemia-footer-grid-item">
          <a href="https://www.linkedin.com/company/1107730" target="_blank">
            <Icon
              type="linkedin"
              :rounded="true"
              backgroundColor="#0077B5"
              borderColor="#0077B5"
            />
          </a>
        </div>
      </div>

      <div class="bohemia-footer-divider" />

      <Legal />
    </div>
  </footer>
</template>

<script>
import Legal from "./partials/Legal";
import Icon from "./../partials/Icon";

export default {
  name: "bohemia-footer",
  components: { Legal, Icon },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css?family=Palanquin+Dark" rel="stylesheet');
@import "./../../assets/scss/footer/misc";
@import "/../../assets/scss/breakpoints";
@import "~sanitize.css";

a {
  color: #ffffff;
  text-decoration: none;
}

.bohemia-footer {
  background-color: #63666a;
  color: #fff;
  text-align: center;
  padding: 2em 0;
  line-height: 2;
  font-size: 14px;
  font-family: "Palanquin Dark", sans-serif;
}

.bohemia-footer-container {
  max-width: 980px;
  margin: 0 auto;
}

.bohemia-footer-grid {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.bohemia-footer-grid-item {
  padding: 0 15px;
}

.bohemia-footer-grid-links {
  flex-wrap: wrap;
  @media (max-width: $brMedium) {
    .bohemia-footer-grid-item-grow {
      flex: 1 0 50%;
    }
  }

  @media (max-width: $brSmall) {
    flex-direction: column;

    .bohemia-footer-grid-item-grow {
      flex: 1;
    }
  }
}

.bohemia-footer-grid-social {
  flex-wrap: wrap;

  @media (max-width: $brMedium) {
    .bohemia-footer-grid-item {
      padding: 0 8px;
    }
  }
}

.bohemia-footer-grid-item-grow {
  flex: 1;
}

.bohemia-footer-title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 1em;
}
</style>
